<spk-card [class]="'col-md-6'" meta="{{commandResponse.CreationDate}}" title="#{{commandResponse.Id}}" [divider]="true">
  <div id="title-extra-info">
    <span class="col-sm">
      <h6 class="d-inline-block">App:</h6> {{commandResponse.ApplicationName}}
    </span>
    <span class="col-sm">
      <h6 class="d-inline-block">Machine:</h6> {{commandResponse.MachineName}}
    </span>
  </div>

  <hr />
  <h6 class="d-inline-block">HTTP: </h6> <span> {{commandResponse.HTTPMethod}}</span>
  <p>{{commandResponse.URL}}</p>
  <h6>User:</h6>
  <p>{{getUser}}</p>
  <hr />
  <h6>Type:</h6>
  <p>{{commandResponse.Type}}</p>
  <h6>Message:</h6>
  <p>{{commandResponse.Message}}</p>
  <h6>Detail:</h6>
  <p>{{commandResponse.Detail}}</p>
</spk-card>